import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Carousel from 'shared-components/Carousel/Carousel';
import Button from 'shared-components/Button/Button';
import PreviewProductCard from '../PreviewProductCard/PreviewProductCard';
import styles from './PreviewProductsMobile.module.css';

const PRODUCT_CARD_MARGIN = 6;

const PreviewProductsMobile = ({
  title,
  subtitle,
  products,
  buttonText,
  buttonAction,
}) => {
  const [sliderWidth, setSliderWidth] = useState(0);

  //subtract PRODUCT_CARD_MARGIN to account for margin between cards
  const productCardWidth = (sliderWidth - PRODUCT_CARD_MARGIN) / 2;
  const slideCount = Math.ceil(_.size(products) / 2);
  return (
    <div className={styles.container}>
      <h2>{title}</h2>
      <p>{subtitle}</p>
      <Carousel
        setParentSliderWidth={setSliderWidth}
        slideCount={slideCount}
        carouselHeightClassName={styles.carousel}
        cardMargin={PRODUCT_CARD_MARGIN}
      >
        {_.chunk(products, 2).map((group) => (
          <div
            className={styles.productCardContainer}
            key={_.get(group, '[0].name')}
          >
            {group.map((card) => (
              <PreviewProductCard
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...card}
                style={{
                  width: productCardWidth,
                  marginRight: PRODUCT_CARD_MARGIN,
                }}
                isMobileDevice
              />
            ))}
          </div>
        ))}
      </Carousel>
      <Button onClick={buttonAction}>{buttonText}</Button>
    </div>
  );
};

PreviewProductsMobile.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  products: PropTypes.arrayOf(
    PropTypes.shape({
      brandName: PropTypes.string,
      name: PropTypes.string.isRequired,
      salePrice: PropTypes.string,
      price: PropTypes.string,
      imageUrl: PropTypes.string.isRequired,
      percentOff: PropTypes.number.isRequired,
    })
  ).isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonAction: PropTypes.func.isRequired,
};

export default PreviewProductsMobile;
